// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"2c0eed34","87":"1e6e9acd","356":"236fa18e","453":"7293cc9b","494":"de62443f","609":"8c516b95","617":"b392b641","982":"7dd183c5"}[chunkId] + ".chunk.js";
};